import classNames from 'classnames';
import React from 'react';
import DangerouslySetInnerHTML from './DangerouslySetInnerHTML';
import * as styles from './SVGIcon.module.scss';
import Slot from './Slot';

export type SVGIconSize = 'small' | 'regular' | 'large' | number;

interface SVGIconProps
  extends Omit<
    React.HTMLAttributes<HTMLDivElement>,
    'dangerouslySetInnerHTML'
  > {
  children?: string | null;
  inline?: boolean;
  size?: SVGIconSize;
}

const SVGIcon = React.forwardRef<HTMLDivElement, SVGIconProps>(
  ({ children = null, inline = false, size = 'regular', ...props }, ref) =>
    children ? (
      <Slot {...props}>
        <DangerouslySetInnerHTML html={children}>
          <div
            ref={ref}
            className={classNames(styles.icon, {
              [styles.inline]: inline,
              [styles.large]: size === 'large',
              [styles.small]: size === 'small',
            })}
            style={typeof size === 'number' ? { fontSize: size } : undefined}
          />
        </DangerouslySetInnerHTML>
      </Slot>
    ) : null,
);

SVGIcon.displayName = 'SVGIcon';

export default SVGIcon;
